import React, { useEffect, useState } from "react";
import S from "./EventCountDown.style";

type Props = {
  event: {
    dateTimePicker: string;
    eventTitle: string;
  };
};

function EventCountDown({ event }: Props) {
  const [showCD, setShowCD] = useState(true);

  const formattedDate = (date: string) => {
    const newMonth = new Date(date.replace(/-/g, "/")).toLocaleDateString(
      "en-US",
      {
        month: "short",
      }
    );

    const time = date.slice(11, 19);

    const newDate =
      newMonth + " " + date.slice(8, 10) + ", " + date.slice(0, 4) + " " + time;

    return newDate;
  };

  const countDownDate = new Date(formattedDate(event.dateTimePicker)).getTime();
  const now = new Date().getTime();
  const distance = countDownDate - now;

  useEffect(() => {
    if (distance < 0) {
      setShowCD(false);
    } else {
      setShowCD(true);
    }
  }, [showCD]);

  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );

  return (
    <>
      {showCD && (
        <S.Container>
          <S.H4>{event.eventTitle}</S.H4>
          <S.EventWrapper>
            <S.ContentWrapper>
              <S.H1>{days}</S.H1>
              <S.H3>dagar</S.H3>
            </S.ContentWrapper>
            <S.ContentWrapper>
              <S.H1>{hours}</S.H1>
              <S.H3>timmar</S.H3>
            </S.ContentWrapper>
          </S.EventWrapper>
        </S.Container>
      )}
    </>
  );
}

export default EventCountDown;
